import { gql } from '@/__generated__/storefront';

export const customerLoyaltyPointsQuery = gql(`
  query LoyaltyPoints($customerAccessToken: String!) {
    customer(customerAccessToken: $customerAccessToken) {
      loyaltyPoints: metafield(key: "loyalty_points", namespace: "hobbii") {
        value
      }
    }
  }
`);

export const customerOrdersQuery = gql(`
  query CustomerOrders($customerAccessToken: String!, $first: Int!, $sortKey: OrderSortKeys, $reverse: Boolean, $cursor: String) {
    customer(customerAccessToken: $customerAccessToken) {
      orders(first: $first, after: $cursor, sortKey: $sortKey, reverse: $reverse) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          cursor
          node {
            id
            orderNumber
            fulfillmentStatus
            processedAt
            statusUrl
            shippingAddress {
              address1
            }
            totalPrice {
              amount
              currencyCode
            }
            lineItems(first: 30) {
              pageInfo {
                hasNextPage
              }
              edges {
                node {
                  variant {
                    requiresShipping
                  }
                }
              }
            }

          }
        }
      }
    }
  }
`);

export const predictiveSearchQuery = gql(`
  query suggestions($query: String!) {
    predictiveSearch(
      query: $query
      types: [PRODUCT]
      searchableFields: [VARIANTS_SKU]
    ) {
      products {
        id
        title
        onlineStoreUrl
        featuredImage {
          url
          altText
          height
          width
        }
        sanityEntityId: metafield(namespace: "hobbii", key: "entity_id") {
          value
        }
        hobbiiSku: metafield(namespace: "hobbii", key: "sku") {
          value
        }
        openCartId: metafield(namespace: "hobbii", key: "opencart_id") {
          value
        }
      }
    }
  }
`);

export const variantLoyaltyPointsQuery = gql(`
  query variantPointsCost($id: ID!) {
    node(id: $id) {
    ... on ProductVariant {
      id
      metafield(key: "loyalty_points_cost", namespace: "hobbii") {
        value
      }
    }
  }
}`);
